import { render, staticRenderFns } from "./viewPromotion.vue?vue&type=template&id=360beb27&scoped=true&"
import script from "./viewPromotion.vue?vue&type=script&lang=js&"
export * from "./viewPromotion.vue?vue&type=script&lang=js&"
import style0 from "./viewPromotion.vue?vue&type=style&index=0&id=360beb27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360beb27",
  null
  
)

export default component.exports